export const STEP_CANDIDATES = [250, 500, 1000, 2000, 2500, 5000, 10000, 20000];
